import React from "react";
import { usePhoneReminder } from "./hooks/usePhoneReminder";

const styles = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  button: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "130px",
    minHeight: "34px",
    padding: "7px 14px",
    border: 0,
    borderRadius: "8px",
    color: "#ffffff",
    backgroundColor: "#2e7d32",
    fontSize: "0.9rem",
    fontWeight: 700,
    cursor: "pointer",
    visibility: "visible",
  },
  disabled: {
    cursor: "not-allowed",
    opacity: 0.65,
  },
  status: {
    color: "#a1acb7",
    fontSize: "0.78rem",
    fontWeight: 600,
    lineHeight: 1.2,
    maxWidth: "260px",
    overflowWrap: "anywhere",
  },
  success: {
    color: "#81c784",
  },
  warning: {
    color: "#ffcc80",
  },
  error: {
    color: "#ffb4ab",
  },
};

export const PhoneReminderButton = ({ phoneNumber, parent, student }) => {
  const { working, status, statusKind, disabled, send } = usePhoneReminder({
    phoneNumber,
    parent,
    student,
  });

  return (
    <span style={styles.wrapper} data-testid="phone-reminder-button">
      <button
        type="button"
        style={{
          ...styles.button,
          ...(disabled ? styles.disabled : null),
        }}
        aria-disabled={disabled}
        onClick={send}
      >
        {working ? "Sending..." : "Send Reminder"}
      </button>
      {status ? (
        <span
          style={{
            ...styles.status,
            ...(statusKind === "success" ? styles.success : null),
            ...(statusKind === "warning" ? styles.warning : null),
            ...(statusKind === "error" ? styles.error : null),
          }}
        >
          {status}
        </span>
      ) : null}
    </span>
  );
};
